import React from 'react';
import { Plus, Trash2, ArrowUp, ArrowDown } from 'lucide-react';
import { ImageField } from './ImageField';

const EMPTY = { image: '', title: '', subtitle: '', category: '' };
const inputCls = 'w-full px-3 py-2 border border-[rgba(17,17,17,0.12)] rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#1b3352]';

export const GalleryEditor = ({ items = [], onChange }) => {
  const update = (i, key, val) => onChange(items.map((it, idx) => (idx === i ? { ...it, [key]: val } : it)));
  const remove = (i) => onChange(items.filter((_, idx) => idx !== i));
  const move = (i, d) => {
    const next = [...items];
    [next[i], next[i + d]] = [next[i + d], next[i]];
    onChange(next);
  };

  return (
    <div className="space-y-4" data-testid="gallery-editor">
      {items.map((it, i) => (
        <div key={i} className="border border-[rgba(17,17,17,0.08)] rounded-xl p-4 grid md:grid-cols-[1fr_1fr] gap-4" data-testid={`gallery-editor-item-${i}`}>
          <ImageField value={it.image} onChange={(v) => update(i, 'image', v)} testId={`gallery-${i}`} />
          <div className="space-y-2">
            <input className={inputCls} placeholder="Título" value={it.title} onChange={(e) => update(i, 'title', e.target.value)} data-testid={`gallery-title-${i}`} />
            <input className={inputCls} placeholder="Subtítulo" value={it.subtitle} onChange={(e) => update(i, 'subtitle', e.target.value)} data-testid={`gallery-subtitle-${i}`} />
            <input className={inputCls} placeholder="Categoría (ej: Láser, Impresión 3D, El taller)" value={it.category} onChange={(e) => update(i, 'category', e.target.value)} data-testid={`gallery-category-${i}`} />
            <div className="flex gap-2 pt-1">
              <button type="button" disabled={i === 0} onClick={() => move(i, -1)} className="p-2 rounded-md border disabled:opacity-30" data-testid={`gallery-up-${i}`}><ArrowUp className="w-4 h-4" /></button>
              <button type="button" disabled={i === items.length - 1} onClick={() => move(i, 1)} className="p-2 rounded-md border disabled:opacity-30" data-testid={`gallery-down-${i}`}><ArrowDown className="w-4 h-4" /></button>
              <button type="button" onClick={() => remove(i)} className="p-2 rounded-md border text-red-600 ml-auto" data-testid={`gallery-remove-${i}`}><Trash2 className="w-4 h-4" /></button>
            </div>
          </div>
        </div>
      ))}
      <button type="button" onClick={() => onChange([...items, { ...EMPTY }])} className="px-4 py-2 rounded-lg border-2 border-dashed border-[#1b3352]/30 text-[#1b3352] flex items-center gap-2 text-sm font-semibold" data-testid="gallery-add-item">
        <Plus className="w-4 h-4" /> Añadir foto
      </button>
    </div>
  );
};
